import React from "react"

import { useParams } from "react-router-dom"

import { PoliciesListType } from "@common-shared/config/oneVerify/oneVerifyPolicies.config"
import { OneVerifyPermission } from "@common-shared/config/rolesPermissions.config"

import { useScrollFix } from "@front-shared/hooks/scrollFix.hook"

import { useHasPermissions } from "../../../hooks/hasPermissions.hook"
import { NotFoundComponent } from "../../general/notFound.component"
import { SinglePolicyViewComponent } from "./singlePolicyView.component"

export const SinglePolicyOverrideComponent: React.FunctionComponent = () => {
    useScrollFix()

    useHasPermissions([OneVerifyPermission.overrideCoverageData])

    const { nirvanaRequestId } = useParams()

    return nirvanaRequestId ? (
        <div className="relative">
            <SinglePolicyViewComponent
                nirvanaRequestId={nirvanaRequestId}
                listType={PoliciesListType.OVERRIDES}
            />
        </div>
    ) : (
        <NotFoundComponent />
    )
}
